module.exports = __webpack_public_path__ + "static/media/logos5.6a2cea68.png";